import React, { useState, useEffect } from 'react';
import { reelDiscovery } from '../api';

export default function CreatorSpotlight() {
  const [creators, setCreators] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    reelDiscovery.getCreatorSpotlight()
      .then(data => setCreators(data.creators || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div style={{ padding: 16, color: 'var(--reels-muted, #666)' }}>Loading creators...</div>;
  }

  if (!creators.length) return null;

  return (
    <div style={{ padding: '12px 0' }}>
      <h4 style={{ color: '#f5a623', marginBottom: 12, fontSize: 14, fontWeight: 700 }}>
        🌟 Creator Spotlight
      </h4>
      <div style={{ display: 'flex', gap: 12, overflowX: 'auto', paddingBottom: 8 }}>
        {creators.slice(0, 10).map((creator) => (
          <div
            key={creator.id}
            style={{
              minWidth: 140,
              padding: 12,
              borderRadius: 12,
              background: 'var(--reels-card-bg, rgba(255,255,255,0.04))',
              border: '1px solid var(--reels-border, #2a3a48)',
              textAlign: 'center',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            <div style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: creator.avatar ? `url(${creator.avatar}) center/cover` : 'var(--reels-border, #2a3a48)',
              margin: '0 auto 8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 20,
              color: 'var(--reels-fg, #fff)',
            }}>
              {!creator.avatar && creator.name?.[0]?.toUpperCase()}
            </div>
            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--reels-fg, #fff)' }}>{creator.name}</div>
            {creator.username && (
              <div style={{ fontSize: 11, color: '#4ecb8d' }}>@{creator.username}</div>
            )}
            <div style={{ fontSize: 11, color: 'var(--reels-muted, #999)', marginTop: 4 }}>
              {creator._count?.followerFollows || 0} followers
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
